import {PatientSettingsScreen} from './PatientSettings';
import {SuperAdminSettings} from './SuperAdminSettings';
import {SpecialistSettings} from './SpecialistSettings';
import React from 'react';
import {useRole} from '@/hooks';

export const SettingsScreen: React.FC = () => {
  const {isPatient, isSuperAdmin, isSpecialist} = useRole();

  if (isPatient) {
    return <PatientSettingsScreen />;
  }
  if (isSuperAdmin) {
    return <SuperAdminSettings />;
  }
  if (isSpecialist) {
    return <SpecialistSettings />;
  }

  return (
    <div>
      <h1>Settings</h1>
    </div>
  );
};
